import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import {
  createSupplierCreditApplicationTemplate,
  getCreditApplicationTemplates,
  getCreditApplicationTemplate,
  updateCreditApplicationTemplate,
} from '../services/creditApplicationsTemplatesService';
import { CreditApplicationTemplatesInitialState } from '../globalSlices/creditApplicationTemplatesSlice';

export const createSupplierCreditApplicationTemplateExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationTemplatesInitialState>
) => {
  const reducerId = 'createSupplierCreditApplicationTemplate';
  builder.addCase(createSupplierCreditApplicationTemplate.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createSupplierCreditApplicationTemplate.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(
    createSupplierCreditApplicationTemplate.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};
export const getCreditApplicationTemplatesExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationTemplatesInitialState>
) => {
  const reducerId = 'getCreditApplicationTemplates';
  builder.addCase(getCreditApplicationTemplates.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getCreditApplicationTemplates.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload?.success && action.payload.data) {
        state.creditApplicationTemplates = action.payload.data;
      }
    }
  );
  builder.addCase(getCreditApplicationTemplates.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getCreditApplicationTemplateExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationTemplatesInitialState>
) => {
  const reducerId = 'getCreditApplicationTemplate';
  builder.addCase(getCreditApplicationTemplate.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.creditApplicationTemplate = null;
  });
  builder.addCase(
    getCreditApplicationTemplate.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload?.success && action.payload.data) {
        state.creditApplicationTemplate = action.payload.data;
      }
    }
  );
  builder.addCase(getCreditApplicationTemplate.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updateCreditApplicationTemplateExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationTemplatesInitialState>
) => {
  const reducerId = 'updateCreditApplicationTemplate';
  builder.addCase(updateCreditApplicationTemplate.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    updateCreditApplicationTemplate.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(updateCreditApplicationTemplate.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
